export const comments_5618661 = {"data":{"data":[],"links":{}}}